import { OrderFulfillmentStatus, OrderMethod, PaymentMethod } from './Constants';

export const FAKE_ORDER = {
  id: 10733,
  fulfillment_id: 691,
  number: 263,
  fulfillment_status: OrderFulfillmentStatus.Created,
  user: { name: 'Max Mustermann', phone_number: '4915245156528' },
  original_price: 43.0,
  total_amount: 25.1,
  tip: 5,
  service_fee: 0.18,
  method: OrderMethod.Pickup,

  customer_note: 'Bitte nicht klingeln, sondern anrufen bei Ankunft. Ist ganz wichtig da das Kind schläft. Danke!!',
  delivery_street_name: 'Heidermann-Straße',
  delivery_street_number: '2',
  delivery_city: 'Bonn',
  delivery_company_name: 'Restaurant Crema',
  delivery_doorbell_name: '2a',
  method_fee: 2,
  delivery_zip_code: 53177,
  coupon_type: 'FIXED',
  line_items: [
    {
      id: 3166,
      product_id: 278,
      name: 'HOMEI Bowl',
      description: 'Frischer Salat auf Reis + 6 gedämpfte Gyoza einer Sorte + 1 Sauce',
      image_url: null,
      thumbnail_url: null,
      product_original_price: 10,
      product_actual_price: 10,
      original_price: 20.8,
      actual_price: 20.8,
      quantity: 1,
      note: 'Please use extra onions and leave out the jalapenous from the burito. Thank you',
      modifier_groups: [
        {
          id: 1,
          name: 'Sauces',
          is_required: false,
          is_variant: false,
          max_count: 3,
          sorting_order: 1,
        },
      ],
      modifiers: [
        {
          id: 2,
          uuid: 2,
          modifier_group_id: 1,
          name: 'Fleisch-Mix: 2x Huhn, 2x Rind und 2x Garnele',
          original_price: 0.3,
          actual_price: 0.3,
          quantity: 1,
          sorting_order: 1,
        },
        {
          id: 3,
          uuid: 3,
          modifier_group_id: 1,
          name: 'Garnele, Wasserkastanie, Limette und Ingwer',
          original_price: 0.5,
          actual_price: 0.5,
          quantity: 1,
          sorting_order: 2,
        },
        {
          id: 4,
          uuid: 4,
          modifier_group_id: 1,
          name: 'Hühnerfleisch, Shitake-Pilze und Lauch',
          original_price: 0.5,
          actual_price: 0.5,
          quantity: 1,
          sorting_order: 3,
        },
      ],
    },
    {
      id: 3167,
      product_id: 280,
      name: 'Salat mit Edamame-Bohnen und eine Sauche nach geschmack',
      description: null,
      image_url: null,
      thumbnail_url: null,
      product_original_price: 10,
      product_actual_price: 10,
      original_price: 22.3,
      actual_price: 22.3,
      quantity: 1,
      note: null,
      modifier_groups: [
        {
          id: 1,
          name: 'Sauces',
          is_required: false,
          is_variant: false,
          max_count: 3,
          sorting_order: 1,
        },
        {
          id: 2,
          name: 'Gyoza Sorten',
          is_required: false,
          is_variant: false,
          max_count: 3,
          sorting_order: 2,
        },
      ],
      modifiers: [
        {
          id: 2,
          uuid: 5,
          modifier_group_id: 1,
          name: 'Fleisch-Mix: 2x Huhn, 2x Rind und 2x Garnele',
          original_price: 0.3,
          actual_price: 0.3,
          quantity: 1,
          sorting_order: 1,
        },
        {
          id: 3,
          uuid: 6,
          modifier_group_id: 2,
          name: 'Garnele, Wasserkastanie, Limette und Ingwer',
          original_price: 0.5,
          actual_price: 0.5,
          quantity: 1,
          sorting_order: 2,
        },
        {
          id: 4,
          uuid: 7,
          modifier_group_id: 1,
          name: 'Koriander-Sauce',
          original_price: 0.5,
          actual_price: 0.5,
          quantity: 1,
          sorting_order: 3,
        },
        {
          id: 4,
          uuid: 8,
          modifier_group_id: 2,
          name: 'Hühnerfleisch, Shitake-Pilze und Lauch',
          original_price: 0.5,
          actual_price: 0.5,
          quantity: 1,
          sorting_order: 4,
        },
      ],
    },
  ],
  created_at: '2022-03-30T14:22:25.000000Z',
  estimated_preparation_time: 30,
  estimated_pickup_time: '2022-03-30T15:25:59.000000Z',
  scheduled_for: '2022-03-30T15:25:59.000000Z',
  payment: {
    id: 1,
    payment_method_id: PaymentMethod.Cash,
    adjustments: [],
  },
};
